import autobind from 'autobind-decorator'
import { Store } from 'libx'
import Project from 'domain/Project'
import { runInAction, action, observable, computed } from 'mobx'
import { task } from 'mobx-task'
import { browserHistory } from 'react-router'
import { makeMomentSorter } from '@taxfyle/web-commons/lib/utils/arrayUtil'
import memoize from 'memoizee'
import links from '../misc/links'

@autobind
export default class ProjectStore extends Store {
  @observable loading = false

  constructor () {
    super(...arguments)
    this.rootStore.authStore.onLogout(action(() => {
      this.fetchProjects.clear()
      this.projects.clear()
    }))
    this.projects = this.collection({
      model: Project
    })
    this.rootStore.api.jobs.on('created', this.onRemoteUpdate)
    this.rootStore.api.jobs.on('updated', this.onRemoteUpdate)
    this.rootStore.api.jobs.on('patched', this.onRemoteUpdate)
    this.fetchProject = this.fetchProject.wrap(fn => memoize(fn, { promise: true, length: 1 }))
    this.fetchProjects = this.fetchProjects.wrap(fn => memoize(fn, { promise: true, length: 0 }))
  }

  @action setLoading (loading) {
    this.loading = loading
  }

  @computed get orderedJobs () {
    return this.projects.map(x => x).sort(makeMomentSorter('desc', x => x.dateModified))
  }

  @action onRemoteUpdate (data) {
    return this.freshenUp(data).then(action(() => {
      const current = this.projects.get(data.id)
      const prevStatus = current && current.status
      const updated = this.projects.set(data)
      if (prevStatus === 'CLAIMED' && updated.status === 'CLOSED') {
        browserHistory.push(links.rateProject(updated.id))
      }
      // const notifyOpts = {
      //   tag: `${updated.id}-${updated.status}`,
      //   icon: updated.provider && updated.provider.avatar,
      //   timeout: 20,
      //   onClick: () => {
      //     browserHistory.push(links.projectDetails(updated.id))
      //   }
      // }
      // if (prevStatus === 'UNCLAIMED' && updated.status === 'CLAIMED') {
      //   this.rootStore.desktopNotificationStore.show({
      //     ...notifyOpts,
      //     title: 'Job picked up!',
      //     body: `${updated.name} just got picked up by ${updated.provider.displayName} - woohoo!`
      //   })
      //   if (updated.conversation) {
      //     this.rootStore.messageStore.fetchMessagesForConversation(updated.conversation.id)
      //   }
      // } else if (prevStatus === 'CLAIMED' && updated.status === 'CLOSED') {
      //   this.rootStore.desktopNotificationStore.show({
      //     ...notifyOpts,
      //     title: 'Job closed!',
      //     body: `${updated.name} was closed by ${updated.provider.displayName} - what a great day it is!`
      //   })
      //   browserHistory.push(links.rateProject(updated.id))
      // }
      return updated
    }))
  }

  projectForConversation (conversationId) {
    return this.projects.find(x => x.conversationId === conversationId)
  }

  @task async fetchProject (projectId) {
    return this.rootStore.api.jobs.get(projectId).then(action(this.projects.set))
  }

  @task async fetchProjects () {
    const jobs = await this.rootStore.retryOnNetworkFailure(() => this.rootStore.api.jobs.find())
    if (jobs === false) {
      this.fetchProjects.clear()
      return
    }

    // Auth profiles are too minimal, refresh that shit.
    await Promise.all(jobs.map((job) => this.freshenUp(job)))
    runInAction(() => {
      this.projects.set(jobs)
    })
  }

  @task async calculatePrice (jobId) {
    return this.rootStore.api.jobs.price(jobId)
  }

  async freshenUp (job) {
    // `job` is not a Project instance but what we get from the API.
    const providerId = job.provider_user_id
    return Promise.all([
      providerId && this.rootStore.userStore.refreshProfile(providerId),
      job.layerConversation &&
        job.status === 'CLAIMED' &&
        this.rootStore.messageStore.fetchMessagesForConversation(job.layerConversation)
    ])
  }

  async rate (project, params) {
    const result = await this.rootStore.api.jobs.rate(project.id, params)
    this.projects.set(result)
  }

  async createJob (data) {
    return this.rootStore.api.jobs.create(data).then(action(this.projects.set))
  }

  async updateJob (id, data) {
    return this.rootStore.api.jobs.patch(id, data).then(action(this.projects.set))
  }
}



// WEBPACK FOOTER //
// ./src/client/store/ProjectStore.js